// Control segmentado (rediseño): dos o tres vistas excluyentes de una misma
// seccion (Bandeja | Carga por franja, Hoy | Mañana). Botones con
// `aria-pressed` dentro de un grupo con nombre, como en el prototipo.
import { cn } from "./cn.js";

export interface SegmentOption<T> {
  value: T;
  label: string;
  disabled?: boolean;
}

interface Props<T> {
  /** Nombre del grupo, para el lector de pantalla. */
  label: string;
  value: T;
  options: readonly SegmentOption<T>[];
  onChange: (value: T) => void;
  className?: string;
}

export function Segmented<T extends string | null>({ label, value, options, onChange, className }: Props<T>): React.JSX.Element {
  return (
    <div role="group" aria-label={label} className={cn("flex gap-0.5 self-start rounded-md border border-linea bg-hundida p-[3px]", className)}>
      {options.map((option) => {
        const on = option.value === value;
        return (
          <button
            key={option.label}
            type="button"
            aria-pressed={on}
            disabled={option.disabled === true}
            onClick={() => onChange(option.value)}
            className={cn(
              "h-[26px] rounded-sm px-2.5 text-xs font-medium transition-colors duration-150 ease-estandar disabled:cursor-not-allowed disabled:opacity-45",
              on ? "bg-velo-activo text-blanco" : "text-texto-suave hover:text-texto-2",
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
